// extracted by mini-css-extract-plugin
export default {"wrapper":"GanttTable_wrapper__8Dqio","outlined":"GanttTable_outlined__LsxKq","tableWrapper":"GanttTable_tableWrapper__EEX2G"};